import Icon from 'src/ui/atoms/icon';
import styled from 'styled-components';

export const DeleteIcon = styled(Icon)`
  margin-left: 0.5rem;
`;

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
